import { Modal, Form } from 'react-bootstrap';

const ContactDetailsModal = ({ show, onHide, contact }) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Contact Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Control type="text" placeholder="Search..." />
                </div>
                <div className="d-flex align-items-center border-top mt-3 pt-3">
                    <div className="c-avatar c-avatar-text me-3">
                        J
                    </div>
                    <div className='w-100'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                <div className="p-tag fw-bold">John Doe</div>
                                <div className="p-tag">john.doe@example.com</div>
                                <div className="p-tag">+1 234 567 890</div>
                            </div>
                            <div>
                                <Form.Check type="checkbox" />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ContactDetailsModal;
